import { useNavigate } from "react-router-dom";
import cogoToast from "cogo-toast";
import {
  useGetUserProfileQuery,
  useGetOrdersByUserIdQuery,
  useLogoutMutation,
} from "../../store/slices/user-slice";

/*
 * Profile session. Wraps the same getUserProfile / logout calls the old
 * account page made, so the cookie-based auth contract is unchanged.
 */
export const useProfile = () => {
  const navigate = useNavigate();
  const { data, isLoading, isError } = useGetUserProfileQuery();
  const [logout] = useLogoutMutation();

  const signOut = async () => {
    try {
      await logout().unwrap();
      cogoToast.success("Signed out.");
      navigate(process.env.PUBLIC_URL + "/");
    } catch (error) {
      cogoToast.error("Sign out failed. Please try again.");
      console.error("Logout failed:", error);
    }
  };

  return { user: data?.user, isLoading, isError, signOut };
};

/*
 * Order history. The endpoint answers 404 when the customer has no orders
 * past the pending stage, which is an empty state rather than a failure —
 * so it is reported separately from a real error.
 */
export const useProfileOrders = (userId) => {
  const { data, isFetching, error } = useGetOrdersByUserIdQuery(userId, {
    skip: !userId,
  });

  const isEmpty = error?.status === 404;

  return {
    orders: data?.orders || [],
    orderCount: data?.orderCount || 0,
    totalSpent: data?.totalSpent || 0,
    isFetching,
    isEmpty,
    isError: Boolean(error) && !isEmpty,
  };
};
